/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragOutlined } from '@ant-design/icons';
import dayjs from 'utils/dayjs';
import getSymbolFromCurrency from 'currency-symbol-map';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { DOMAIN } from '../../../../SellingRateCalendarPage/state/constants';
import { useInjectSaga } from '../../../../../utils/redux/injectSaga';
import { useInjectReducer } from '../../../../../utils/redux/injectReducer';
import reducer from '../../../../SellingRateCalendarPage/state/reducer';
import saga from '../../../../SellingRateCalendarPage/state/saga';
import { Header, HeaderContainer, DragContainer, ScrollableBody } from '../../../../DashboardPage/GridComponents';
import messages from './messages';
import { statsService } from '../../../../../utils/api';
import Table from '../../../../../components/Table';
import { ROOM_RECOMMENDATION_STATUS } from 'right-revenue-microservice-sdk/lib/constants';
import { isEmpty, isNaN, orderBy } from 'lodash';
import { Skeleton } from 'antd';
import { Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart } from 'recharts';
import '../../accountManagement.css';
import { downloadExcel } from '../../../../../utils/fileDownload';
import Button from '../../../../../components/forms/Button';
import { makeColumnFilteringProps } from '../../shared';
import ReactCardFlip from 'react-card-flip';

const { Column } = Table;

const Recommendations = ({ isDraggable, token, propertyUuids, individualPropertyID }) => {
    useInjectReducer({ key: DOMAIN, reducer });
    useInjectSaga({ key: DOMAIN, saga });
    const intl = useIntl();
    const [fetching, setFetching] = useState(false);
    const [fetchingExport, setFetchingExport] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [data, setData] = useState([]);
    const [isFlipped, setFlipped] = useState(false);
    const [graphData, setGraphData] = useState();
    const [selectedProperty, setSelectedProperty] = useState('');
    const [selectedPropertyUuid, setSelectedPropertyUuid] = useState('');

    const dragContainer = isDraggable && (
        <DragContainer className="draggable-item">
            <DragOutlined />
        </DragContainer>
    );

    const loadData = async () => {
        setFetching(true);
        setFetched(false);
        let recData = [];
        if (individualPropertyID) {
            const response = await statsService({
                token,
            }).getAccountManagementRecommendations({
                start: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
                end: dayjs().format('YYYY-MM-DD'),
                propertyID: individualPropertyID,
            });
            recData = response?.data || [];
        } else {
            const response = await statsService({
                token,
            }).getAccountManagementRecommendations({
                start: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
                end: dayjs().format('YYYY-MM-DD'),
            });
            recData = response?.data || [];
        }
        if (!isEmpty(propertyUuids)) {
            recData = recData.filter(({ uuid }) => propertyUuids.includes(uuid));
        }
        setData(recData);
        setFetching(false);
        setFetched(true);
    };

    const onExportData = async () => {
        setFetchingExport(true);
        const params = {
            start: dayjs().subtract(1, 'years'),
            end: dayjs().add(1, 'years'),
        };
        const excelFile = await statsService({
            token,
            propertyId: selectedPropertyUuid,
        }).getRoomRecommendationsReport(params);

        downloadExcel(excelFile.data, `recommendations-${selectedProperty}.xlsx`);
        setFetchingExport(false);
    };

    const handleFlip = async (record) => {
        if (!isFlipped) {
            setSelectedProperty(record.name);
            setSelectedPropertyUuid(record.uuid);
            setFetching(true);
            setFetched(false);
            const response = await statsService({
                token,
            }).getAccountManagementRecommendationsOneProperty({
                start: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
                end: dayjs().format('YYYY-MM-DD'),
                propertyID: record.id,
            });
            const monthlyData = response.data.map((d) => ({
                ...d,
                stayDateFormatted: dayjs(d.stayDate).format('MMM-YY'),
            }));
            setGraphData(orderBy(monthlyData, [(item) => dayjs(item.stayDate).format('YYYY-MM')], ['asc']));
            setFetching(false);
            setFetched(true);
        }

        setFlipped(!isFlipped);
    };

    useEffect(() => {
        loadData();
    }, [propertyUuids]);

    const renderPercent = (val, total) => {
        if (!val) {
            return 'n/a';
        }
        return (
            <FormattedNumber
                value={total === 0 ? 0 : val / total}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
                style="percent"
            />
        );
    };

    const percentSorter = (a, b, type) => {
        const aFraction = isNaN(a[type] / a.total) ? 0 : a[type] / a.total;
        const bFraction = isNaN(b[type] / b.total) ? 0 : b[type] / b.total;
        return aFraction - bFraction;
    };

    return (
        <>
            <HeaderContainer>
                <Header>{intl.formatMessage(messages.title)}</Header>
                {dragContainer}
            </HeaderContainer>
            <ScrollableBody>
                {fetching && (
                    <>
                        <Skeleton active />
                        <Skeleton active />
                        <Skeleton active />
                    </>
                )}
                {!fetching && fetched && (
                    <>
                        <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
                            <div>
                                <div
                                    style={{
                                        width: '100%',
                                        padding: '7px',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    <FormattedMessage {...messages.description} />
                                </div>
                                <Table
                                    dataSource={data}
                                    pagination={{
                                        pageSize: 31,
                                        hideOnSinglePage: true,
                                    }}
                                    rowKey="name"
                                    tableLayout="auto"
                                    size="small"
                                    scroll={{ y: 325 }}
                                    onRow={(record) => ({
                                        onClick: () => {
                                            handleFlip(record);
                                        },
                                    })}
                                >
                                    <Column
                                        width="20%"
                                        dataIndex="name"
                                        title={<FormattedMessage {...messages.nameColumnTitle} />}
                                        sorter={(a, b) => a.name.localeCompare(b.name)}
                                        defaultSortOrder="ascend"
                                        {...makeColumnFilteringProps(data, 'name')}
                                    />
                                    <Column
                                        width="13%"
                                        dataIndex="total"
                                        title={<FormattedMessage {...messages.totalColumnTitle} />}
                                        sorter={(a, b) => a.total - b.total}
                                    />
                                    <Column
                                        width="13%"
                                        dataIndex={ROOM_RECOMMENDATION_STATUS.ACCEPTED}
                                        title={<FormattedMessage {...messages.acceptedColumnTitle} />}
                                        render={(value, obj) => renderPercent(value, obj.total)}
                                        sorter={(a, b) => percentSorter(a, b, ROOM_RECOMMENDATION_STATUS.ACCEPTED)}
                                    />
                                    <Column
                                        width="13%"
                                        dataIndex={ROOM_RECOMMENDATION_STATUS.AUTO_ACCEPTED}
                                        title={<FormattedMessage {...messages.autoAcceptedColumnTitle} />}
                                        render={(value, obj) => renderPercent(value, obj.total)}
                                        sorter={(a, b) => percentSorter(a, b, ROOM_RECOMMENDATION_STATUS.AUTO_ACCEPTED)}
                                    />
                                    <Column
                                        width="13%"
                                        dataIndex={ROOM_RECOMMENDATION_STATUS.DECLINED}
                                        title={<FormattedMessage {...messages.declinedColumnTitle} />}
                                        render={(value, obj) => renderPercent(value, obj.total)}
                                        sorter={(a, b) => percentSorter(a, b, ROOM_RECOMMENDATION_STATUS.DECLINED)}
                                    />
                                    <Column
                                        width="13%"
                                        dataIndex={ROOM_RECOMMENDATION_STATUS.OVERTYPED}
                                        title={<FormattedMessage {...messages.overtypedColumnTitle} />}
                                        render={(value, obj) => renderPercent(value, obj.total)}
                                        sorter={(a, b) => percentSorter(a, b, ROOM_RECOMMENDATION_STATUS.OVERTYPED)}
                                    />
                                    <Column
                                        width="13%"
                                        dataIndex="overtype"
                                        title={<FormattedMessage {...messages.overtypedTotalColumnTitle} />}
                                        render={(value, record) => (
                                            <>
                                                {getSymbolFromCurrency(record.currency)}
                                                <FormattedNumber
                                                    value={value / 100}
                                                    minimumFractionDigits={2}
                                                    maximumFractionDigits={2}
                                                />
                                            </>
                                        )}
                                        sorter={(a, b) => a.overtype - b.overtype}
                                    />
                                </Table>
                            </div>
                            <div>
                                <div
                                    style={{
                                        width: '100%',
                                        textAlign: 'center',
                                        fontSize: '1.1em',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {selectedProperty}
                                </div>
                                <ResponsiveContainer
                                    width="100%"
                                    height={500}
                                    className="card-content"
                                    onClick={handleFlip}
                                >
                                    <BarChart
                                        data={graphData}
                                        margin={{
                                            top: 20,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                        onClick={handleFlip}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="stayDateFormatted" />
                                        <YAxis />
                                        <Tooltip />
                                        <Legend />
                                        <Bar
                                            dataKey="accepted"
                                            stackId="a"
                                            fill="#82ca9d"
                                            name={intl.formatMessage(messages.acceptedColumnTitle)}
                                        />
                                        <Bar
                                            dataKey="declined"
                                            stackId="a"
                                            fill="#e45567"
                                            name={intl.formatMessage(messages.declinedColumnTitle)}
                                        />
                                        <Bar
                                            dataKey="auto_accepted"
                                            stackId="a"
                                            fill="#8884d8"
                                            name={intl.formatMessage(messages.autoAcceptedColumnTitle)}
                                        />
                                        <Bar
                                            dataKey="overtyped"
                                            stackId="a"
                                            fill="#ffbf00"
                                            name={intl.formatMessage(messages.overtypedColumnTitle)}
                                        />
                                    </BarChart>
                                </ResponsiveContainer>
                                <div>
                                    <Button size="small" onClick={onExportData} loading={fetchingExport}>
                                        <FormattedMessage {...messages.exportButton} />
                                    </Button>
                                </div>
                            </div>
                        </ReactCardFlip>
                    </>
                )}
            </ScrollableBody>
        </>
    );
};

Recommendations.propTypes = {
    token: PropTypes.string.isRequired,
    propertyUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Recommendations;
